import Vue from 'vue'
import Vuex from 'vuex'
import { manageCampaigns } from './manageCampaigns/index'

Vue.use(Vuex)

const store = {
  state: {
    version: '1.0.0'
  },
  modules: {
    manageCampaigns
  }
}

export default new Vuex.Store(store)
